/**
 * Sign in with Apple and Google (Stage 9, 2026-10-26). Off until Sam has done the setup in docs/social-sign-in-setup.md
 * (Apple Developer, Google Cloud, Supabase providers): with it off the two buttons never show and nothing else changes.
 * Same idiom as festivalMaps.js: a build-time constant, greppable, the dead branch droppable. A dev build shows the
 * buttons with ?socialauth=1, for review.
 *
 * The Google client IDs are not secrets (they ship inside every app that signs in with Google); the client SECRET lives
 * only in the Supabase dashboard.
 */
export const SOCIAL_SIGN_IN_ENABLED = false;

/** Google Cloud -> Credentials -> the iOS OAuth client (bundle app.prii). Its reversed form is also a URL scheme in
 *  ios/App/App/Info.plist. */
export const GOOGLE_IOS_CLIENT_ID = '';
/** Google Cloud -> Credentials -> the Web OAuth client (the one Supabase's Google provider uses). */
export const GOOGLE_WEB_CLIENT_ID = '';

export function socialSignInShown() {
  if (SOCIAL_SIGN_IN_ENABLED) return true;
  if (!import.meta.env.DEV || typeof window === 'undefined') return false;
  return new URLSearchParams(window.location.search).get('socialauth') === '1';
}
